document.addEventListener("DOMContentLoaded", function () {
    function checkVisibility() {
        const targetElement = document.querySelector(".addtocard-dummy-to");
        const stickyButton = document.querySelector(".stickyorabtn");

        if (!targetElement || !stickyButton) return; // Exit if elements are missing

        const rect = targetElement.getBoundingClientRect();
        const isInViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;

        if (isInViewport) {
            stickyButton.style.display = "none";
        } else {
            stickyButton.style.display = "block";
        }
    }

    function waitForElements() {
        const targetElement = document.querySelector(".addtocard-dummy-to");
        const stickyButton = document.querySelector(".stickyorabtn");

        if (targetElement && stickyButton) {
            checkVisibility();
            window.addEventListener("scroll", checkVisibility);
            window.addEventListener("resize", checkVisibility);
        } else {
            // Retry after a short delay if elements are not found
            setTimeout(waitForElements, 500);
        }
    }

    waitForElements(); // Start checking for elements
});
